import React from 'react'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import HeroImage from 'components/hero-image'
import Form from 'components/forms/transfer'
import { Helmet } from 'react-helmet'
import Layout from 'components/layout'
import Content from 'components/content'

const TransferPage = ({ data: { heroImage } }) => {
  return (
    <Layout>
      <Helmet>
        <title>Equipment Transfer Request | Hutson Inc</title>
        <meta
          name='description'
          content='Need a unit that Hutson Inc has in stock? Fill out a transfer request form and we will get back with you as soon as possible.'
        />
        <script type='application/ld+json'>
          {JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'BreadcrumbList',
            'itemListElement': [
              {
                '@type': 'ListItem',
                'position': 1,
                'name': 'Hutson Inc',
                'item': 'https://www.hutsoninc.com/',
              },
              {
                '@type': 'ListItem',
                'position': 2,
                'name': 'Equipment Transfer Request',
                'item': 'https://www.hutsoninc.com/transfer/',
              },
            ],
          })}
        </script>
      </Helmet>

      <HeroImage title='Equipment Transfer Request Form' image={heroImage} />

      <Content>
        <Message>
          Are you a dealership and need a unit that Hutson Inc has in stock? Fill out the form below
          and we’ll get back to you.
        </Message>

        <Form name='Equipment Transfer' />
      </Content>
    </Layout>
  )
}

const Message = styled.p`
  margin-bottom: 40px;
`

export const pageQuery = graphql`
  {
    heroImage: file(relativePath: { eq: "transfer-bg.jpg" }) {
      ...FullWidthImage
    }
  }
`

export default TransferPage
